import { PageTransition } from '@/constant/transition'
import { fetchInterests } from '@/util/ref'
import type { InterestCategory, Interest } from '@/util/ref'
import { useMutation, useQuery } from '@tanstack/react-query'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import { useNavigate } from 'react-router-dom'
import { syncInterests } from '../helper'
import Container from 'react-bootstrap/esm/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useEffect, type JSX } from 'react'
import Card from 'react-bootstrap/Card'
import { cardStyle, active } from './style.css'
import { useSelectable } from '@/hook'
import clsx from 'clsx'
import { ProgressFlags } from '@/util/progress'
import { syncProgress } from '../helper'
import { fetchUserInterests } from './data'
import { queryClient } from '@/util/queryClient'

export default function InterestSelection() {
  const navigate = useNavigate()
  const {
    data: userInterests,
    // isLoading: interestsLoading,
    // isError: interestsError,
  } = useQuery<Interest[]>({
    queryKey: ['profile', 'interest'],
    queryFn: fetchUserInterests,
    staleTime: 1000 * 60 * 60,
  })
  const {
    data: interestCategories,
    isLoading,
    isError,
  } = useQuery<InterestCategory[]>({
    queryKey: ['interest'],
    queryFn: fetchInterests,
    staleTime: 1000 * 60 * 5,
  })

  // const [interestIds, setInterestIds] = useAtom(interestIdsAtom)
  const [selectedInterestIds, toggle, reset] = useSelectable<number>([], 5)
  const interestsMutation = useMutation({
    mutationFn: (interestIds: number[]) => syncInterests(interestIds),
    onSuccess: () => {
      // setInterestIds(selectedInterestIds)
      queryClient.invalidateQueries({ queryKey: ['profile', 'interest'] })
      syncProgress(ProgressFlags.INTERESTS_SELECTED)
      navigate('/onboarding/tutorial', {
        state: { direction: PageTransition.FromRight },
      })
    },
    onError: (err) => console.log(err),
  })

  useEffect(() => {
    reset(userInterests ? userInterests.map(({ id }) => id) : [])
  }, [reset, userInterests])

  return (
    <Container>
      <h1>あなたが興味があることを教えて</h1>
      <p className="text-muted small">最終段階です。最大5つまで選択してください</p>
      <p className="small text-muted">選択済み: {selectedInterestIds.length}/1（最低）</p>
      {isError ? (
        <option>error</option>
      ) : isLoading ? (
        <option>Loading...</option>
      ) : (
        <Container>
          {interestCategories?.reduce<JSX.Element[]>((acc, cur, i, arr) => {
            const next = arr[i + 1]
            if (i % 2 === 0) {
              acc.push(
                <Row className="mb-2" key={`row-${cur.id}`}>
                  <Col key={cur.id}>
                    <Card
                      className={clsx(
                        cardStyle,
                        selectedInterestIds.includes(cur.reprId) && active
                      )}
                      onClick={() => toggle(cur.reprId)}
                    >
                      <Card.Body>
                        <b>
                          {cur.emoji} {cur.name}
                        </b>
                        {/*
                          <div className="text-muted">
                            {cur.interests.map((i) => i.name).join(', ')}
                          </div>
                        */}
                      </Card.Body>
                    </Card>
                  </Col>
                  {next && (
                    <Col key={next.id}>
                      <Card
                        className={clsx(
                          cardStyle,
                          selectedInterestIds.includes(next.reprId) && active
                        )}
                        onClick={() => toggle(next.reprId)}
                      >
                        <Card.Body>
                          <b>
                            {next.emoji} {next.name}
                          </b>
                          {/*
                            <div className="text-muted">
                              {next.interests.map((i) => i.name).join(', ')}
                            </div>
                          */}
                        </Card.Body>
                      </Card>
                    </Col>
                  )}
                </Row>
              )
            }
            return acc
          }, [])}
        </Container>
      )}
      <Stack direction="horizontal">
        <Button
          variant="outline-secondary"
          size="lg"
          onClick={() =>
            navigate('/onboarding/occupation', {
              state: { direction: PageTransition.FromLeft },
            })
          }
        >
          ←
        </Button>
        <Button
          variant="outline-primary"
          size="lg"
          className="ms-auto"
          disabled={selectedInterestIds.length < 1}
          onClick={() => {
            interestsMutation.mutate(selectedInterestIds)
          }}
        >
          →
        </Button>
      </Stack>
    </Container>
  )
}
